module.exports = __webpack_public_path__ + "assets/img/singularA.14c51265.png";